var map = {
	"./sezione1.svg": 2160,
	"./sezione11.svg": 5297,
	"./sezione16.svg": 5390,
	"./sezione21.svg": 7368,
	"./sezione26.svg": 7175,
	"./sezione31.svg": 1055,
	"./sezione6.svg": 719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1870;